import { Button, Headline1, Meta } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCityParkingStore } from 'stores/cityParkingStore';
import { ColumnWithMargins, StyledWrapper } from 'styles/ContainerStyles';
import { Container } from '../styles/styles';

interface NoPmcsFoundProps {
  testID: string;
}

const NoPmcsFound: React.FC<NoPmcsFoundProps> = ({ testID }) => {
  const { t } = useTranslation();
  return (
    <Container testID={testID}>
      <StyledWrapper center>
        <ColumnWithMargins mt={40} mb={40}>
          <Headline1 center testID="city-pmcs-not-found-title">
            {t('search.noMatches')}
          </Headline1>
        </ColumnWithMargins>
        <StyledWrapper center mb={40}>
          <Meta testID="city-pmcs-not-found-meta" center>
            {t('cityPermits.notFoundWithSearch')}
          </Meta>
        </StyledWrapper>
        <StyledWrapper center maxWidth={400}>
          <Button
            text={t('cityPermits.showAvailable')}
            buttonType="secondary"
            size="l"
            onPress={() => useCityParkingStore.getState().setSearchTerm('')}
          />
        </StyledWrapper>
      </StyledWrapper>
    </Container>
  );
};

export default NoPmcsFound;
